// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__-t+qR","invalid":"styles_invalid__V+UuT","secondary":"styles_secondary__hXUeb","prefix":"styles_prefix__OLoeJ","input":"styles_input__Gxly2"};